module.exports = __webpack_public_path__ + "img/ic_error_outline.ec81dbf5.svg";